<template>
    <v-container fluid pr-4 pl-4>
        <div class="filters-presa">
            <!-- Filtri -->
            <v-row class="pt-4" align="end">
                <v-col cols="12" lg="11" class="gestione-filters">
                    <v-row align="end">
                        <v-col cols="12" sm="6" md="4" lg="2" class="pb-2">
                            <label class="d-block mb-1">Completate</label>
                            <v-select outlined dense hide-details
                                      v-model="selectedStatoPesa"
                                      :items="statiPresa"
                                      item-text="name"
                                      item-value="value"
                                      @change="addToUrl('stato', selectedStatoPesa)"/>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="2" class="pb-2">
                            <label class="d-block mb-1">Associazione</label>
                            <v-select outlined dense hide-details
                                      v-model="selectedOperatoreAssociato"
                                      :items="operatoriPresa"
                                      item-text="rName"
                                      item-value="_id"
                                      @change="addToUrl('oa', selectedOperatoreAssociato)"/>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" lg="3" class="search-client pb-2">
                            <label class="d-block mb-1">Cliente</label>
                            <v-autocomplete label="Cerca per nome, cognome o email"
                                            cache-items flat dense hide-details
                                            hide-no-data
                                            return-object
                                            clearable
                                            solo-inverted
                                            prepend-inner-icon="mdi-magnify"
                                            :search-input.sync="searchUser"
                                            :items="listUsers"
                                            item-text="rNameSearchUser"
                                            v-model="selectedUser"
                                            @change="addToUrl('user', selectedUser && selectedUser._id ? selectedUser._id : '')" />
                        </v-col>
                        <v-col cols="12" sm="6" md="3" lg="2" class="pb-2">
                            <label class="d-block mb-1">Tipologia</label>
                            <v-select v-model="filtroBici"
                                      :items="['officina', 'negozio', 'online', 'noleggio', 'esposizione']"
                                      multiple outlined dense hide-details
                                      @change="changeFiltroBici"/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" lg="1" class="pb-2">
                            <label class="d-block mb-1">Numero</label>
                            <v-text-field v-model="searchNumber" @input="initSearchPresa" outlined dense hide-details/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" lg="2" class="pb-2">
                            <label class="d-block mb-1">Consegna</label>
                            <v-menu v-model="calendarDataConsegna" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="viewDataConsegna" prepend-inner-icon="mdi-calendar" readonly v-on="on" outlined dense hide-details/>
                                </template>
                                <v-date-picker v-model="dataConsegna" @input="changeDataConsegna"/>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="1" class="text-right d-flex align-center justify-end pb-3">
                    <v-btn icon color="grey darken-3" @click="clearFilter" title="Reset filtri" class="mr-1">
                        <i class="fas fa-sync"></i>
                    </v-btn>
                    <v-btn icon color="grey darken-3" @click="modalEsportazione = true" title="Esporta">
                        <i class="fas fa-download"></i>
                    </v-btn>
                </v-col>
            </v-row>

            <!-- Counter cards -->
            <v-row class="pt-4">
                <v-col cols="6" sm="auto" @click="goTo('/gestione?tab=1&non_assegnate=true')">
                    <v-card class="filter-card rounded-xl"
                            :class="$route.query.non_assegnate === 'true' && !$route.query.verificate ? 'active' : ''"
                    >
                        <v-card-title class="pb-6">Non assegnate</v-card-title>
                        <v-card-subtitle>{{ (counters && counters.prese_non_assegnate) || 0 }}</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="6" sm="auto" @click="goTo('/gestione?tab=1&non_assegnate=true&verificate=true')">
                    <v-card class="filter-card rounded-xl"
                            :class="$route.query.non_assegnate === 'true' && $route.query.verificate === 'true' ? 'active' : ''"
                    >
                        <v-card-title class="pb-6">Verificate non assegnate</v-card-title>
                        <v-card-subtitle>{{ (counters && counters.prese_verificate_non_assegnate) || 0 }}</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="6" sm="auto" @click="goTo('/gestione?tab=tab-1&in_lavorazione=true')">
                    <v-card class="filter-card rounded-xl"
                            :class="$route.query.in_lavorazione === 'true' ? 'active' : ''"
                    >
                        <v-card-title class="pb-6">In lavorazione</v-card-title>
                        <v-card-subtitle>{{ (counters && counters.prese_in_lavorazione) || 0 }}</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="6" sm="auto" @click="goTo('/gestione?tab=tab-1&in_ritardo=true')">
                    <v-card class="filter-card rounded-xl"
                            :class="$route.query.in_ritardo === 'true' ? 'active' : ''"
                    >
                        <v-card-title class="pb-6">In ritardo</v-card-title>
                        <v-card-subtitle>{{ (counters && counters.prese_in_ritardo) || 0 }}</v-card-subtitle>
                    </v-card>
                </v-col>
                <v-col cols="6" sm="auto" @click="goTo('/gestione?tab=tab-1&bloccate=true')">
                    <v-card class="filter-card rounded-xl"
                            :class="$route.query.bloccate === 'true' ? 'active' : ''"
                    >
                        <v-card-title class="pb-6">Bloccate</v-card-title>
                        <v-card-subtitle>{{ (counters && counters.prese_bloccate) || 0 }}</v-card-subtitle>
                    </v-card>
                </v-col>
            </v-row>

            <!-- Loading -->
            <template v-if="loadingPrese">
                <v-row class="mt-16">
                    <v-col cols="12" class="text-center">
                        <i class="fas fa-circle-notch fa-spin"></i> LOADING
                    </v-col>
                </v-row>
            </template>

            <template v-if="!loadingPrese">
                <!-- Desktop: tabella -->
                <v-simple-table v-if="!$vuetify.breakpoint.xsOnly" class="content-table table-lavorazioni">
                    <thead>
                    <tr>
                        <th class="text-left" />
                        <th class="text-left">Ordine</th>
                        <th class="text-left">Cliente</th>
                        <th class="text-left">Bici</th>
                        <th class="text-left">Creazione</th>
                        <th class="text-left">Tempo previsto</th>
                        <th class="text-left">Dt. Lavoro</th>
                        <th class="text-left">Consegna Desiderata</th>
                        <th class="text-left">Consegna Reale</th>
                        <th class="text-left">Associato</th>
                        <th class="text-left"/>
                        <th class="text-left"/>
                        <th class="text-left"/>
                        <th class="text-left"/>
                        <th class="text-center" data-tooltip title="Lavaggio"><i class="fas fa-shower"></i></th>
                        <th class="text-center" data-tooltip title="Fatta"><i class="fas fa-check"></i></th>
                        <th class="text-center" data-tooltip title="Assegnata"><i class="fas fa-user-friends"></i></th>
                        <th class="text-center" data-tooltip title="Pagata"><i class="fas fa-dollar-sign"></i></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="presa in listPrese" :key="presa._id">
                        <td style="min-width: 100px" @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">
                            <b>
                                <span v-if="presa && presa.verificata"><i class="fas fa-check" style="color: #34b7f1"></i></span>
                                # {{ presa.numero }}
                            </b>
                            <br>
                            <small v-if="presa.tipo === 0 || !presa.tipo">Officina</small>
                            <small v-else-if="presa.tipo === 1">Negozio</small>
                            <small v-else-if="presa.tipo === 2">Online</small>
                            <small v-else-if="presa.tipo === 3">Noleggio / Test</small>
                            <small v-else-if="presa.tipo === 4">Esposizione</small>
                        </td>
                        <td>
                            <span v-if="presa.id_ordine && presa.ordine && presa.ordine[0] && presa.ordine[0].numero">
                                <div style="display: flex; align-items: center">
                                    <div v-if="presa.ordine && presa.ordine[0] && presa.ordine[0].dettagli_ordine && presa.ordine[0].dettagli_ordine.montaggio_prodotti && presa.ordine[0].dettagli_ordine.montaggio_prodotti.tipologia" class="ml-2 mt-1">
                                        <template v-if="presa.ordine[0].dettagli_ordine.montaggio_prodotti.tipologia === 'deluxe'">
                                            <img data-tooltip title="Montaggio deluxe" src="/montaggio-deluxe.svg" width="25" height="25" alt="Montaggio deluxe">
                                        </template>
                                        <template v-if="presa.ordine[0].dettagli_ordine.montaggio_prodotti.tipologia === 'standard'">
                                            <img data-tooltip title="Montaggio smart" src="/montaggio-smart.svg" width="25" height="25" alt="Montaggio smart">
                                        </template>
                                    </div>
                                    <div class="ml-1">#{{ presa.ordine[0].numero }}</div>
                                    <div v-if="presa.ordine[0].spedizione_premium" class="ml-1">
                                        <i class="fas fa-crown" style="color: #c29436; font-size: 15px !important;"></i>
                                    </div>
                                </div>
                            </span>
                        </td>
                        <td @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})"><b>{{ presa.rNameUser }}</b></td>
                        <td style="max-width: 500px;" @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})"><b>{{ presa.rNameBike }}</b></td>
                        <td @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">{{ presa.viewDataPresa }}</td>
                        <td @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">{{ presa.tempoPrevisto }}</td>
                        <td @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">{{ presa.viewDataLavoro }}</td>
                        <td @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">{{ presa.viewDataConsegnaDesiderata }}</td>
                        <td @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">{{ presa.viewDataConsegna }}</td>
                        <td @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">{{ presa.rNameOperatore }}</td>
                        <td>
                            <router-link :to="{ path: '/dettagli', query: { _id: presa._id }}">
                                <i class="fas fa-tasks"></i>
                            </router-link>
                        </td>
                        <td>
                            <router-link :to="{ path: '/presa', query: { _id: presa._id }}">
                                <i class="far fa-edit"></i>
                            </router-link>
                        </td>
                        <td>
                            <i @click="eliminaPresa(presa._id)" class="fas fa-trash" style="color: #222"></i>
                        </td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <i style="color: #222" class="fas fa-print" v-on="on"/>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <a @click="apriPagina(rConfig.domainAdmin + '/admin/prese/stampa_meccanico?_id='+presa._id)"><v-list-item-title>Copia Meccanico</v-list-item-title></a>
                                    </v-list-item>
                                    <v-list-item>
                                        <a @click="apriPagina(rConfig.domainAdmin + '/admin/prese/stampa?_id='+presa._id)"><v-list-item-title>Saldo cliente</v-list-item-title></a>
                                    </v-list-item>
                                    <v-list-item v-if="presa.id_ordine">
                                        <a @click="apriPagina(rConfig.domainAdmin + '/admin/ordini/stampa?_id='+presa.id_ordine)"><v-list-item-title>Copia ordine cliente</v-list-item-title></a>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td class="text-center">
                            <i v-if="presa.lavaggio" class="fas fa-shower"/>
                        </td>
                        <td class="text-center">
                            <label class="fancy-checkbox in-form">
                                <input type="checkbox" disabled :checked="presa.completata" hidden>
                                <i class="far fa-circle unchecked"/>
                                <i class="fas fa-check-circle checked"/>
                            </label>
                        </td>
                        <td class="text-center associato">
                            <label class="fancy-checkbox in-form">
                                <input type="checkbox" disabled :checked="presa.operatore_associato" hidden>
                                <i class="far fa-circle unchecked"/>
                                <i class="fas fa-check-circle checked"/>
                            </label>
                        </td>
                        <td class="text-center">
                            <label class="fancy-checkbox in-form">
                                <input type="checkbox" disabled :checked="presa.pagamento && presa.pagamento.pagato" hidden>
                                <i class="far fa-circle unchecked"/>
                                <i class="fas fa-check-circle checked"/>
                            </label>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>

                <!-- Mobile: card -->
                <div v-else class="mt-2">
                    <v-card v-for="presa in listPrese" :key="presa._id"
                            class="presa-card mb-3 rounded-lg"
                            @click="$router.push({ path: '/dettagli', query: { _id: presa._id }})">
                        <v-card-text class="pa-3">

                            <!-- Header: numero + tipo + azioni -->
                            <div class="presa-card__header">
                                <div class="presa-card__numero">
                                    <i v-if="presa && presa.verificata" class="fas fa-check presa-card__verificata mr-1"></i>
                                    <strong># {{ presa.numero }}</strong>
                                    <span class="presa-card__tipo ml-2">
                                        <template v-if="presa.tipo === 0 || !presa.tipo">Officina</template>
                                        <template v-else-if="presa.tipo === 1">Negozio</template>
                                        <template v-else-if="presa.tipo === 2">Online</template>
                                        <template v-else-if="presa.tipo === 3">Noleggio / Test</template>
                                        <template v-else-if="presa.tipo === 4">Esposizione</template>
                                    </span>
                                </div>
                                <div class="presa-card__actions" @click.stop>
                                    <router-link :to="{ path: '/dettagli', query: { _id: presa._id }}" class="mr-2">
                                        <i class="fas fa-tasks"></i>
                                    </router-link>
                                    <router-link :to="{ path: '/presa', query: { _id: presa._id }}" class="mr-2">
                                        <i class="far fa-edit"></i>
                                    </router-link>
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on }">
                                            <i class="fas fa-print mr-2" style="color: #505d68" v-on="on"/>
                                        </template>
                                        <v-list>
                                            <v-list-item>
                                                <a @click="apriPagina(rConfig.domainAdmin + '/admin/prese/stampa_meccanico?_id='+presa._id)"><v-list-item-title>Copia Meccanico</v-list-item-title></a>
                                            </v-list-item>
                                            <v-list-item>
                                                <a @click="apriPagina(rConfig.domainAdmin + '/admin/prese/stampa?_id='+presa._id)"><v-list-item-title>Saldo cliente</v-list-item-title></a>
                                            </v-list-item>
                                            <v-list-item v-if="presa.id_ordine">
                                                <a @click="apriPagina(rConfig.domainAdmin + '/admin/ordini/stampa?_id='+presa.id_ordine)"><v-list-item-title>Copia ordine cliente</v-list-item-title></a>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <i class="fas fa-trash" style="color: #505d68" @click="eliminaPresa(presa._id)"></i>
                                </div>
                            </div>

                            <!-- Cliente + Bici -->
                            <div class="presa-card__cliente mt-2">
                                <strong>{{ presa.rNameUser }}</strong>
                                <div class="presa-card__bici">{{ presa.rNameBike }}</div>
                            </div>

                            <!-- Ordine -->
                            <div v-if="presa.id_ordine && presa.ordine && presa.ordine[0] && presa.ordine[0].numero" class="presa-card__order mt-2">
                                <span class="presa-card__label">Ordine:</span>
                                <span class="ml-1">#{{ presa.ordine[0].numero }}</span>
                                <img v-if="presa.ordine[0].dettagli_ordine && presa.ordine[0].dettagli_ordine.montaggio_prodotti && presa.ordine[0].dettagli_ordine.montaggio_prodotti.tipologia === 'deluxe'"
                                     src="/montaggio-deluxe.svg" width="18" height="18" class="ml-1" style="vertical-align: middle" alt="Montaggio deluxe">
                                <img v-if="presa.ordine[0].dettagli_ordine && presa.ordine[0].dettagli_ordine.montaggio_prodotti && presa.ordine[0].dettagli_ordine.montaggio_prodotti.tipologia === 'standard'"
                                     src="/montaggio-smart.svg" width="18" height="18" class="ml-1" style="vertical-align: middle" alt="Montaggio smart">
                                <i v-if="presa.ordine[0].spedizione_premium" class="fas fa-crown ml-1" style="color: #c29436; font-size: 13px !important;"></i>
                            </div>

                            <!-- Date e info -->
                            <div class="presa-card__dates mt-2">
                                <div v-if="presa.viewDataPresa">
                                    <span class="presa-card__label">Creazione:</span> {{ presa.viewDataPresa }}
                                </div>
                                <div v-if="presa.viewDataLavoro">
                                    <span class="presa-card__label">Dt. Lavoro:</span> {{ presa.viewDataLavoro }}
                                </div>
                                <div v-if="presa.viewDataConsegnaDesiderata">
                                    <span class="presa-card__label">D. Des.:</span> {{ presa.viewDataConsegnaDesiderata }}
                                </div>
                                <div v-if="presa.viewDataConsegna">
                                    <span class="presa-card__label">Consegna:</span> {{ presa.viewDataConsegna }}
                                </div>
                            </div>

                            <div class="presa-card__meta mt-1">
                                <span v-if="presa.tempoPrevisto">
                                    <span class="presa-card__label">Tempo:</span> {{ presa.tempoPrevisto }}
                                </span>
                                <span v-if="presa.rNameOperatore" class="ml-3">
                                    <span class="presa-card__label">Assoc.:</span> {{ presa.rNameOperatore }}
                                </span>
                            </div>

                            <!-- Status badges -->
                            <div class="presa-card__status mt-2">
                                <span v-if="presa.lavaggio" class="presa-card__badge">
                                    <i class="fas fa-shower"></i> Lavaggio
                                </span>
                                <span class="presa-card__badge" :class="presa.completata ? 'presa-card__badge--on' : 'presa-card__badge--off'">
                                    <i :class="presa.completata ? 'fas fa-check-circle' : 'far fa-circle'"></i> Fatta
                                </span>
                                <span class="presa-card__badge" :class="presa.operatore_associato ? 'presa-card__badge--on' : 'presa-card__badge--off'">
                                    <i :class="presa.operatore_associato ? 'fas fa-check-circle' : 'far fa-circle'"></i> Assegnata
                                </span>
                                <span class="presa-card__badge" :class="presa.pagamento && presa.pagamento.pagato ? 'presa-card__badge--on' : 'presa-card__badge--off'">
                                    <i :class="presa.pagamento && presa.pagamento.pagato ? 'fas fa-check-circle' : 'far fa-circle'"></i> Pagata
                                </span>
                            </div>

                        </v-card-text>
                    </v-card>
                </div>
            </template>

            <v-row class="mt-2">
                <v-col cols="12" sm="4" offset-sm="4">
                    <v-pagination v-model="page" @input="addToUrl('page', page)" :length="lengthPagination" circle />
                </v-col>
            </v-row>
        </div>
        <template>
            <div class="text-center">
                <v-dialog v-model="modalEsportazione" width="500">
                    <v-card>
                        <v-card-title class="text-h5 primary">
                            Esporta
                        </v-card-title>
                        <v-row class="pa-4">
                            <v-col cols="6">
                                <v-menu ref="menuDa"
                                        v-model="menuDa"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="esportaDa"
                                                      label="Da"
                                                      prepend-icon="mdi-calendar"
                                                      readonly
                                                      v-bind="attrs"
                                                      v-on="on" />
                                    </template>
                                    <v-date-picker v-model="esportaDa" @change="saveExportDa" type="month"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <v-menu ref="menuA"
                                        v-model="menuA"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="esportaA"
                                                      label="A"
                                                      prepend-icon="mdi-calendar"
                                                      readonly
                                                      v-bind="attrs"
                                                      v-on="on" />
                                    </template>
                                    <v-date-picker v-model="esportaA" @change="saveExportA" type="month"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="esportaPrese">
                                Esporta
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
    </v-container>
</template>
<script>
import { momentDate } from "@/components/js/formatDate";
import apiUser from '@/components/Presa/cliente/js/user';
import apiPresa from '@/components/Presa/js/presa';
import { generalFunction } from "@/components/js/generalFunction";
import config from "@/config/config";

export default {
    name: 'Tutti',
    props: ['nonAssegnati'],
    data() {
        return {
            page: 1,
            pageSize: 20,
            searchUser: undefined,
            searchNumber: undefined,
            selectedUser: undefined,
            loadingSearchUser: false,
            loadingPrese: false,
            listUsers: [],
            lengthPagination: 0,
            checkOfficina: this.controlReload('officina'),
            checkNegozio: this.controlReload('negozio'),
            checkOnline: this.controlReload('online'),
            checkNoleggio: this.controlReload('noleggio'),
            checkEsposizione: this.controlReload('esposizione'),
            operatoriPresa: [],
            selectedOperatorePresa: this.controlReload('op'),
            selectedOperatoreAssociato: this.controlReload('oa'),
            statiPresa: [
                {
                    name: 'Tutti',
                    value: 0,
                }, {
                    name: 'Completate',
                    value: 1
                }, {
                    name: 'Non completate',
                    value: 2
                }
            ],
            selectedStatoPesa: this.controlReload('stato'),
            calendarDataPresa: false,
            dataPresa: this.$route.query.data_presa,
            viewDataPresa: momentDate(this.$route.query.data_presa),
            calendarDataConsegna: false,
            dataConsegna: this.$route.query.data_consegna,
            viewDataConsegna: momentDate(this.$route.query.data_consegna),
            listPrese: [],
            timeourRicercaUser: undefined,
            brands: [],
            filtri: ['officina', 'negozio', 'online', 'noleggio', 'esposizione'],
            filtroBici: [],
            modalEsportazione: false,
            menuDa: undefined,
            menuA: undefined,
            esportaDa: undefined,
            esportaA: undefined,
            counters: {}
        }
    },
    async created() {
        let brands = [] = await generalFunction.getBrands();
        if (
            brands &&
            brands[1]
        ) {
            for (let brand of brands[1]) {
                brand.rName = 'Senza Nome';
                if (
                    brand &&
                    brand.it &&
                    brand.it.nome
                ) brand.rName = brand.it.nome;
            }
        }
        this.brands = brands[1];
        this.initSearchPresa();
        let token = await generalFunction.getToken();
        if (token) {
            let operatoriPresa = [];
            operatoriPresa.push({  _id: 0, rName: 'Tutti'});
            let operatori = await generalFunction.getOperatori(token);
            if (
                operatori &&
                operatori.length > 0
            ) {
                for (let operatore of operatori) {
                    operatore.rName = '';
                    if (operatore.nome)
                        operatore.rName += operatore.nome + " ";
                    if (operatore.cognome)
                        operatore.rName += operatore.cognome;

                    operatoriPresa.push(operatore)
                }
            }
            this.operatoriPresa = operatoriPresa;
        }

        for (let filtro of this.filtri)
            if (this.$route.query[filtro])
                this.filtroBici.push(filtro);
    },
    methods: {
        async changeFiltroBici() {
            if (
                this.filtroBici &&
                this.filtroBici.length
            ) for (let filtro of this.filtroBici)
                this.$route.query[filtro] = true;

            for (let filtro of this.filtri) {
                if (
                    !this.filtroBici.includes(filtro) &&
                    this.$route.query[filtro]
                ) delete this.$route.query[filtro];
            }

            const params = new URLSearchParams()

            Object.keys(this.$route.query).forEach(key => {
                if (this.$route.query[key] !== null && this.$route.query[key] !== undefined) {
                    params.append(key, this.$route.query[key])
                }
            })

            window.location.href = '/gestione?'+params;
        },
        clearFilter() {
            window.location.href = '/gestione?tab=tab-1'
        },
        controlReload(param) {
            switch (param) {
                case 'stato': {
                    if (
                        this.$route.query[param] ||
                        this.$route.query[param] === 0
                    ) return Number(this.$route.query[param]);
                    else return 0;
                }
                case 'negozio':
                case 'online':
                case 'noleggio':
                case 'esposizione':
                case 'officina': {
                    return  (
                        this.$route.query[param] &&
                        this.$route.query[param] === 'true'
                    )
                }
                case 'oa':
                case 'op': {
                    if (
                        this.$route.query[param] &&
                        this.$route.query[param] !== '0'
                    ) return this.$route.query[param];
                    else return 0;
                }
            }
        },
        changeDataPresa() {
            this.calendarDataPresa = false;
            this.viewDataPresa = momentDate(this.dataPresa);
            this.addToUrl('data_presa', this.dataPresa);
        },
        changeDataConsegna() {
            this.calendarDataConsegna = false;
            this.viewDataConsegna = momentDate(this.dataConsegna);
            this.addToUrl('data_consegna', this.dataConsegna);
        },
        async addToUrl(params, value) {
            await this.$router.push({ path: '/gestione', query: Object.assign({}, this.$route.query,{ [params]: value } )});
            this.initSearchPresa();
        },
        async resetFilter() {
            await this.$router.push({ path: '/gestione', query: Object.assign({}, {})}).catch(() => {});
            this.initSearchPresa();
        },
        async eliminaPresa(id_presa) {
            if(confirm('Sicuro di voler eliminare questa Presa?')) {
                let token = await generalFunction.getToken();
                await apiPresa.deletePresa(token, {
                    _id: id_presa
                });
                this.initSearchPresa();
            }
        },
        async initSearchPresa() {
            this.lengthPagination = 0;
            this.listPrese = [];
            this.loadingPrese = true;

            let token = await generalFunction.getToken();
            if (token) {
                let data = {
                    page: this.page,
                    page_size: this.pageSize
                };

                if (this.$route.query.data_presa)
                    data.data_presa = this.$route.query.data_presa;

                if (this.$route.query.data_consegna)
                    data.data_consegna = this.$route.query.data_consegna;

                if (
                    this.$route.query.officina &&
                    this.$route.query.officina === 'true'
                ) data.officina = true;

                if (
                    this.$route.query.negozio &&
                    this.$route.query.negozio === 'true'
                ) data.negozio = true;

                if (
                    this.$route.query.online &&
                    this.$route.query.online === 'true'
                ) data.online = true;

                if (
                    this.$route.query.noleggio &&
                    this.$route.query.noleggio === 'true'
                ) data.noleggio = true;

                if (
                    this.$route.query.esposizione &&
                    this.$route.query.esposizione === 'true'
                ) data.esposizione = true;

                if (
                    this.$route.query.bloccate &&
                    this.$route.query.bloccate === 'true'
                ) data.bloccate = true;

                if (
                    this.$route.query.in_ritardo &&
                    this.$route.query.in_ritardo === 'true'
                ) data.in_ritardo = true;

                if (
                    this.$route.query.in_lavorazione &&
                    this.$route.query.in_lavorazione === 'true'
                ) data.in_lavorazione = true;

                if (
                    this.$route.query.verificate &&
                    this.$route.query.verificate === 'true'
                ) data.verificate = true;

                if (
                    this.$route.query.non_assegnate &&
                    this.$route.query.non_assegnate === 'true'
                ) data.non_assegnati = true;

                if (this.$route.query.op)
                    data.operatore_presa = this.$route.query.op;

                if (this.$route.query.stato)
                    data.stato = this.$route.query.stato;

                if (this.$route.query.oa)
                    data.operatore_associato = this.$route.query.oa;

                if (this.$route.query.user)
                    data.id_utente = this.$route.query.user;

                if (this.searchNumber)
                    data.search = this.searchNumber;

                let prese = await apiPresa.searchPrese(token, data);
                if (prese) {
                    if (prese[0]) {
                        for (let presa of prese[0]) {
                            presa.rNameUser = '';
                            presa.rNameBike = '';

                            if (presa.data_presa)
                                presa.viewDataPresa = momentDate(presa.data_presa);

                            if (presa.tempo_previsto)
                                presa.tempoPrevisto = presa.tempo_previsto

                            if (presa.data_desiderata_consegna)
                                presa.viewDataConsegnaDesiderata = momentDate(presa.data_desiderata_consegna);

                            if (presa.data_consegna)
                                presa.viewDataConsegna = momentDate(presa.data_consegna);

                            if (presa.data_lavoro)
                                presa.viewDataLavoro = momentDate(presa.data_lavoro);

                            if (
                                presa.user &&
                                presa.user[0]
                            ) {
                                if (presa.user[0].nome)
                                    presa.rNameUser += presa.user[0].nome;

                                if (presa.user[0].cognome)
                                    presa.rNameUser += ' ' + presa.user[0].cognome;

                                if (
                                    presa.id_bici &&
                                    presa.user[0].dettagli_utente &&
                                    presa.user[0].dettagli_utente.bici
                                ) {
                                    let bike = presa.user[0].dettagli_utente.bici.find(bike => {
                                        return bike._id === presa.id_bici;
                                    });

                                    if(
                                        bike &&
                                        bike['marca']
                                    ) {
                                        let rMarca = this.brands.find(brand => {
                                            return brand._id === bike['marca'];
                                        });
                                        if(rMarca)
                                            bike['rMarca'] = rMarca['rName'];
                                    }

                                    if (
                                        bike &&
                                        bike.modello
                                    ) presa.rNameBike = (bike.rMarca ? (bike.rMarca + ' ') : '') + bike.modello;
                                }
                            }

                            if (
                                presa.operatore &&
                                presa.operatore[0]
                            ) {
                                if (presa.operatore[0].nome)
                                    presa.rNameOperatore = presa.operatore[0].nome;
                                else if (presa.operatore[0].cognome)
                                    presa.rNameOperatore = presa.operatore[0].cognome;
                            }
                        }
                        this.listPrese = prese[0];
                    }
                    if (prese[1])
                        this.lengthPagination = Math.ceil(prese[1] / this.pageSize);

                    this.loadingPrese = false;
                } else this.loadingPrese = false;

                this.initCounter(data)
            } else this.loadingPrese = false;

        },
        async initCounter(data) {
            let token = await generalFunction.getToken();
            if (token) {
                let counters = await apiPresa.getCounterPrese(token, data);
                this.counters = counters;
            }
        },
        async startSearchUser(search) {
            if (this.loadingSearchUser) return;
            this.loadingSearchUser = true;
            let token = await generalFunction.getToken();
            if (
                search &&
                token
            ) {
                let data = '';
                data += "&token="+token;
                data += "&cerca="+search;
                let users = await apiUser.searchUsers(data);
                let arrayUsers = [];
                if (
                    users &&
                    users.length
                ) {
                    for (let user of users) {
                        user.rNameSearchUser = '';
                        if (user.nome) user.rNameSearchUser += user.nome;
                        if (user.cognome) user.rNameSearchUser += ' ' + user.cognome;
                        if (user.email) user.rNameSearchUser += ' ' + user.email;
                        if (user.telefono) user.rNameSearchUser += ' (' + user.telefono + ')';
                        arrayUsers.push(user);
                    }
                }
                this.listUsers = arrayUsers
            }
            this.loadingSearchUser = false;
        },
        apriPagina(url) {
            window.open(url)
        },
        saveExportDa(date) {
            this.$refs.menuDa.save(date)
        },
        saveExportA(date) {
            this.$refs.menuA.save(date)
        },
        async esportaPrese() {
            if (
                this.esportaDa &&
                this.esportaA
            ) {
                let token = await generalFunction.getToken();
                let pathFile = await apiPresa.esportaPrese(token, {
                    data_da: this.esportaDa,
                    data_a: this.esportaA
                });
                if (pathFile) {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([pathFile]));
                    link.setAttribute('download', 'EsportazionePrese.csv');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else alert('Non è stata trovata nessuna presa.')
            } else alert('Inserisci le date!');
        },
        goTo(link) {
            if (link) {
                if (this.$route.query.user)
                    link += '&user='+this.$route.query.user;
                if (this.$route.query.stato)
                    link += '&stato='+this.$route.query.stato;
                if (this.$route.query.oa)
                    link += '&oa='+this.$route.query.oa;
                if (this.$route.query.data_consegna)
                    link += '&data_consegna='+this.$route.query.data_consegna;
                if (
                    this.$route.query.officina &&
                    this.$route.query.officina === 'true'
                ) link += '&officina=true';

                if (
                    this.$route.query.negozio &&
                    this.$route.query.negozio === 'true'
                ) link += '&negozio=true';

                if (
                    this.$route.query.online &&
                    this.$route.query.online === 'true'
                ) link += '&online=true';

                if (
                    this.$route.query.noleggio &&
                    this.$route.query.noleggio === 'true'
                ) link += '&noleggio=true';

                if (
                    this.$route.query.esposizione &&
                    this.$route.query.esposizione === 'true'
                ) link += '&esposizione=true';

                window.location.href = link
            }
        }
    },
    watch: {
        nonAssegnati: function () {
            this.initSearchPresa();
        },
        async searchUser(search) {
            clearTimeout(this.timeourRicercaUser);
            let those = this;
            this.timeourRicercaUser = setTimeout(function () {
                those.startSearchUser(search);
            }, 500);
        },
    },
    computed: {
        rConfig() {
            return config;
        }
    }
}
</script>
